import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";



export const HITLBodyContent = () => {

  // refesh cache urls when the end of previous list has been reached
  // if (hitlFilters.endOfCacheReached) {
  //   fetchMore({
  //     variables: {
  //       cursor: hitlFilters.cursor,
  //       search: hitlFilters.urlSearch,
  //       category:
  //         hitlFilters.categoryFilter.value === "ALL"
  //           ? ""
  //           : hitlFilters.categoryFilter.value,
  //     },
  //   // Conditionally render context when the filter is set to ALL
  //   ...(hitlFilters.correctionsFilter.value === "ALL" && {
  //     context: { clientName: "hitlEndpoint" },
  //   }),
  //   updateQuery: (prev, { fetchMoreResult }) => {
  //     fetchMoreResult}

  // })

  // }

  return (
    <Box width={"100%"} mx={"auto"}>
      <Outlet />
    </Box>
  );
};
